import { MinusCircleIcon, PlusCircleIcon } from "@8x8/oxygen-icon";
import React from "react";
import styled from "styled-components";

const CursorPointerSpan = styled.span`
  cursor: pointer;
`;

export default function expandColumnFactory() {
  return {
    id: "expander",
    header: ({ table }) => (
      <CursorPointerSpan onClick={() => table.toggleAllRowsExpanded()}>
        {table.getIsAllRowsExpanded() ? (
          <MinusCircleIcon />
        ) : (
          <PlusCircleIcon />
        )}
      </CursorPointerSpan>
    ),
    cell: ({ row }) => (
      <CursorPointerSpan
        {...{
          onClick: row.getToggleExpandedHandler(),
        }}
      >
        {row.getIsExpanded() ? <MinusCircleIcon /> : <PlusCircleIcon />}
      </CursorPointerSpan>
    ),
    size: 30,
    enableHiding: false,
    enableSorting: false,
    enableDownload: false,
    enableResizing: false,
  };
}
